export const baseWebsite = 'https://chess.kokaine.org/#'
export const baseServer = 'https://chess.kokaine.org/srv'
//export const baseWebsite = 'http://localhost:3000/#'
//export const baseServer = 'http://localhost:5555'
